import { Tag } from "@/src/components/Tag";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const TOOLTIP_TEXT = "The role assigned to the creator of a Data Room";

export function DefaultRoleTag() {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open || !triggerRef.current) {
      return;
    }

    const updatePosition = () => {
      if (!triggerRef.current) {
        return;
      }
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 8,
        left: rect.left + rect.width / 2,
      });
    };

    updatePosition();
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);
    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [open]);

  return (
    <>
      <span
        ref={triggerRef}
        className="inline-flex"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Tag color="persian" text="Default" />
      </span>
      {open
        ? createPortal(
            <div
              className="pointer-events-none fixed z-[9999] -translate-x-1/2 -translate-y-full"
              style={{ top: position.top, left: position.left }}
            >
              <div className="max-w-xs rounded-md border border-gray-900 bg-gray-900 px-3 py-2 shadow-lg">
                <p className="text-sm font-medium text-white">{TOOLTIP_TEXT}</p>
              </div>
            </div>,
            document.body,
          )
        : null}
    </>
  );
}
